import React, { useContext, useMemo } from 'react'
import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import { strCol } from '@integec/grid-tools/lib/cols'
import R from 'ramda'
import { rowHeaderRender } from 'core/utils'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
import {
  DataItemSortIndexByClient,
  getAllDataItemByClient,
} from './HourlyDataItems'
import { connect } from 'react-redux'
import { getClientInfo } from 'core'

// const header = [
//   strCol({
//     ident: 'item',
//     display: 'Item',
//     width: 200,
//     isKey: true,
//     displayFormat: d => d,
//   }),
// ]

const HourlyDetailsDataList = ({
  data,
  date,
  endDate,
  cref,
  graphDivRef,
  CLIENT,
  trueup = false,
  ...props
}) => {
  const dateHeaders = useMemo(
    _ => {
      const dt = date
        .clone()
        .clone()
        .set('hour', 0)
      return R.range(
        1,
        endDate
          .clone()
          .set('hour', 0)
          .add(1, 'd')
          .diff(date, 'HOURS') + 1
      ).map(i => {
        let dat = dt
        const hv = strCol({
          ident:
            dat.format('YYYY-MM-DD') + ' ' + (parseInt(dat.format('H')) + 1),
          display: dat.format('MMM/DD') + ' ' + (parseInt(dat.format('H')) + 1),
          width: i === 1 ? 100 : 100,
          dataFormatter: ({ value }) => {
            // if (!(!!value && isNaN(value) && (value + '').length <= 0))
            if (!value || isNaN(value) || (value + '').length <= 0) return value
            const d = parseFloat(value)
            return d.toFixed(2)
          },
          ellipsis: true,
        })
        dat = dt.add(1, 'hour')
        return hv
      })
    },
    [date, endDate]
  )

  const itHeaders = useMemo(
    _ =>
      strCol({
        ident: 'item',
        display: 'Item',
        width: 150,
        isKey: true,
        sortOrder: 'asc',
        ...toSelectionColProps(getAllDataItemByClient(CLIENT, trueup)),
        sortIndexGetter: ({ rowData }) =>
          DataItemSortIndexByClient(CLIENT, trueup)[rowData.item] || 1000,
        alignment: 'left',
        ellipsis: true,
      }),
    [CLIENT, trueup]
  )
  const ItemHeader = useMemo(_ => [itHeaders, ...dateHeaders], [
    dateHeaders,
    itHeaders,
  ])

  const { setScrollValueLeft } = useContext(MarginAnalysisContext)

  return (
    <React.Fragment>
      <Grid
        headers={ItemHeader}
        data={data}
        // render={renderFlex({ width: 1000, height: 400 })}
        // onSelectionChange={this.selectionChange}
        // selectedRows={this.state.selectedRows}
        render={virtualizedGridRenderer({
          rowHeight: 19,
          contentGridRef: cref,
          autoFixColByKey: true,
          rowHeaderRender,
          height: props.height || 350,
          width: props.width || 800,
          headerRowHeight: 30,
          onScroll: ({ scrollLeft }) => {
            if (graphDivRef.current) {
              setScrollValueLeft(scrollLeft)
              graphDivRef.current.scrollTo({
                left: scrollLeft,
              })
            }
          },
        })}
        selectionType="row"
        // selectionMode="single"
        sortEnabled
        sortOptions={[itHeaders]}
        initialSortOptions={[itHeaders]}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  CLIENT: getClientInfo(state),
})

export default connect(mapStateToProps)(HourlyDetailsDataList)
